module.exports = __webpack_public_path__ + "static/media/dts-image.274d195e.png";